<template>
    <div>
        <v-select :multiple="false" :options="optionsDepartamentos" :placeholder="'Selecciona '+placeholderm"
                  v-model="selectedDepartamentos" @input="setCambio"></v-select>
    </div>
</template>

<script>
export default {
    name: "departamentos",
    props:{
        placeholderm:String,
    },
    data(){
        return{
            selectedDepartamentos:null,
            optionsDepartamentos:[]
        }
    },
    mounted() {
        this.getFabricantes();
    },
    methods:{
        getFabricantes(){
            let $this = this;
            axios.post('/api/AdminCatalogos/departamentosSelect')
                .then(r => {
                        $this.optionsDepartamentos = r.data;
                        //console.log(r);
                    },
                    error => {$this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');}
                );
        },
        setCambio(){
            this.$emit('cambioFabricante');
        }
    }
}
</script>

<style scoped>

</style>
